import React, { useEffect, useState } from 'react';
import supabase from '../../../../supabaseClient';

function CalendarEventDetail({ event, onClose, idConfig }) {
  const [mode, setMode] = useState('view'); // 'view' | 'edit'
  const [deleting, setDeleting] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const [categories, setCategories] = useState([]);
  const [managers, setManagers] = useState([]);
  const [title, setTitle] = useState('');
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  const [categoryId, setCategoryId] = useState('');
  const [assignedTo, setAssignedTo] = useState('');
  const [notes, setNotes] = useState('');

  useEffect(() => {
    if (!event) return;
    setTitle(event.title || '');
    setDate(event.event_date || '');
    setTime(event.event_time?.slice(0, 5) || '');
    setCategoryId(event.category?.id || '');
    setAssignedTo(event.assigned_profile?.id || '');
    setNotes(event.notes || '');
  }, [event]);

  useEffect(() => {
    if (mode !== 'edit' || !idConfig) return;
    supabase.from('calendar_categories').select('id, name').eq('id_configuration', idConfig).then(({ data, error }) => {
      if (error) { console.error('Błąd pobierania kategorii:', error); return; }
      setCategories(data || []);
    });
    supabase.from('profiles').select('id, full_name').eq('profile_type', 'manager').eq('id_configuration', idConfig).then(({ data, error }) => {
      if (error) { console.error('Błąd pobierania managerów:', error); return; }
      setManagers(data || []);
    });
  }, [mode, idConfig]);

  if (!event) return null;

  async function handleDelete() {
    setDeleting(true);
    setError(null);
    const { error: deleteError } = await supabase.from('calendar_events').delete().eq('id', event.id).eq('id_configuration', idConfig);
    setDeleting(false);
    if (deleteError) {
      console.error('Błąd usuwania akcji:', deleteError);
      setError('Nie udało się usunąć akcji.');
      return;
    }
    onClose();
  }

  async function handleSaveEdit() {
    const trimmedTitle = title.trim();
    if (!trimmedTitle) { setError('Tytuł jest wymagany.'); return; }

    setSaving(true);
    setError(null);
    const { error: updateError } = await supabase
      .from('calendar_events')
      .update({
        title: trimmedTitle,
        event_date: date,
        event_time: time,
        category_id: categoryId || null,
        assigned_to: assignedTo || null,
        notes: notes.trim() || null,
      })
      .eq('id', event.id)
      .eq('id_configuration', idConfig);
    setSaving(false);

    if (updateError) {
      console.error('Błąd edycji akcji:', updateError);
      setError('Nie udało się zapisać zmian.');
      return;
    }
    onClose();
  }

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(44,20,25,0.45)', zIndex: 100, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: '#fff', borderRadius: 16, padding: 28, width: 420, maxWidth: '90vw' }}>

        {mode === 'view' && (
          <>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
              <div style={{ width: 12, height: 12, borderRadius: '50%', background: event.category?.color || '#999' }} />
              <div style={{ fontSize: 12, fontWeight: 700, color: event.category?.color || '#999', textTransform: 'uppercase' }}>
                {event.category?.name || 'Bez kategorii'}
              </div>
            </div>
            <div style={{ fontSize: 19, fontWeight: 800, color: '#2C1419', marginBottom: 14 }}>{event.title}</div>
            <div style={{ fontSize: 13, color: '#705A5E', marginBottom: 6 }}>
              📅 {event.event_date} · {event.event_time?.slice(0, 5)}
            </div>
            <div style={{ fontSize: 13, color: '#705A5E', marginBottom: 14 }}>
              Przypisano: {event.assigned_profile?.full_name || '—'}
            </div>
            {event.notes && (
              <div style={{ fontSize: 13, color: '#2C1419', background: '#FDFBF7', borderRadius: 8, padding: '10px 12px', marginBottom: 18 }}>
                {event.notes}
              </div>
            )}
            {error && <div style={{ color: '#c0392b', fontSize: 12, marginBottom: 10 }}>{error}</div>}
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, marginTop: 8 }}>
              <button onClick={handleDelete} disabled={deleting} style={{
                background: 'none', border: '1px solid #f0c9c9', padding: '9px 16px', borderRadius: 8,
                fontSize: 13, fontWeight: 600, color: '#c0392b', cursor: deleting ? 'default' : 'pointer', opacity: deleting ? 0.6 : 1,
              }}>
                {deleting ? 'Usuwanie…' : 'Usuń'}
              </button>
              <div style={{ display: 'flex', gap: 10 }}>
                <button onClick={() => setMode('edit')} style={{
                  background: '#fff', border: '1px solid #e3d9d9', padding: '9px 16px', borderRadius: 8,
                  fontSize: 13, fontWeight: 600, color: '#6B1D2F', cursor: 'pointer',
                }}>
                  Edytuj
                </button>
                <button onClick={onClose} style={{
                  background: '#6B1D2F', border: 'none', padding: '9px 18px', borderRadius: 8,
                  fontSize: 13, fontWeight: 700, color: '#fff', cursor: 'pointer',
                }}>
                  Zamknij
                </button>
              </div>
            </div>
          </>
        )}

        {mode === 'edit' && (
          <>
            <div style={{ fontSize: 18, fontWeight: 800, marginBottom: 16, color: '#6B1D2F' }}>Edytuj akcję</div>

            <label style={labelStyle}>Tytuł</label>
            <input value={title} onChange={(e) => setTitle(e.target.value)} style={inputStyle} />

            <div style={{ display: 'flex', gap: 10, marginBottom: 14 }}>
              <div style={{ flex: 1 }}>
                <label style={labelStyle}>Data</label>
                <input type="date" value={date} onChange={(e) => setDate(e.target.value)} style={inputStyle} />
              </div>
              <div style={{ flex: 1 }}>
                <label style={labelStyle}>Godzina</label>
                <input type="time" value={time} onChange={(e) => setTime(e.target.value)} style={inputStyle} />
              </div>
            </div>

            <label style={labelStyle}>Kategoria</label>
            <select value={categoryId} onChange={(e) => setCategoryId(e.target.value)} style={inputStyle}>
              {categories.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>

            <label style={labelStyle}>Przypisana osoba</label>
            <select value={assignedTo} onChange={(e) => setAssignedTo(e.target.value)} style={inputStyle}>
              {managers.map((m) => <option key={m.id} value={m.id}>{m.full_name}</option>)}
            </select>

            <label style={labelStyle}>Notatka</label>
            <textarea value={notes} onChange={(e) => setNotes(e.target.value)} style={{ ...inputStyle, minHeight: 56, resize: 'vertical' }} />

            {error && <div style={{ color: '#c0392b', fontSize: 12, marginBottom: 10 }}>{error}</div>}

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 8 }}>
              <button onClick={() => setMode('view')} style={{
                background: 'none', border: '1px solid #e3d9d9', padding: '9px 16px', borderRadius: 8,
                fontSize: 13, fontWeight: 600, color: '#705A5E', cursor: 'pointer',
              }}>
                Anuluj
              </button>
              <button onClick={handleSaveEdit} disabled={saving} style={{
                background: '#6B1D2F', border: 'none', padding: '9px 18px', borderRadius: 8,
                fontSize: 13, fontWeight: 700, color: '#fff', cursor: saving ? 'default' : 'pointer', opacity: saving ? 0.6 : 1,
              }}>
                {saving ? 'Zapisywanie…' : 'Zapisz zmiany'}
              </button>
            </div>
          </>
        )}

      </div>
    </div>
  );
}

export default CalendarEventDetail;

const labelStyle = { display: 'block', fontSize: 12, color: '#705A5E', marginBottom: 4 };
const inputStyle = { width: '100%', boxSizing: 'border-box', padding: '9px 10px', border: '1px solid #e3d9d9', borderRadius: 8, fontSize: 14, marginBottom: 14 };